export default __webpack_public_path__ + "static/media/icon-lock.8183910c.svg";